import React from 'react';
import _ from 'lodash';

import { usePaymentInformationWidgetQuery } from 'generated/graphql';
import Big from 'big.js';



export interface IPaymentInformation {
  paymentMethod: string;
  subTotalCents: Big;
  shippingTotalCents: Big;
  taxTotalCents: Big;
  totalCents: Big;
  feeTotalCents: Big;
  discountTotalCents: Big;
}

export interface IData {
  paymentInformation: IPaymentInformation | null;
}

export function useQuery(orderId: string) {
  const queryTuple = usePaymentInformationWidgetQuery({
    variables: {
      orderId
    }
  });



  return React.useMemo(
    () => {
      const subTotalCents = _.reduce(
        queryTuple.data?.orderLite?.lineItems ?? [],
        (sum, lineItem) =>
          sum.add(new Big(lineItem.itemTotalCents)),
        new Big(0));

      const data: IData = {
        paymentInformation: queryTuple.data?.orderLite ? {
          paymentMethod: queryTuple.data.orderLite.paymentMethod.displayName,
          subTotalCents,
          shippingTotalCents: new Big(queryTuple.data.orderLite.shippingTotalCents),
          taxTotalCents: new Big(queryTuple.data.orderLite.taxTotalCents),
          totalCents: new Big(queryTuple.data.orderLite.totalCents),
          feeTotalCents: new Big(queryTuple.data.orderLite.feeTotalCents),
          discountTotalCents: new Big(queryTuple.data.orderLite.discountTotalCents)
        } : null
      };

      return {
        ...queryTuple,
        data
      };
    },
    [queryTuple]
  );
}
